const randomId = () => Math.random().toString(10).slice(2, 7);

export const snippets = [
  {
    label: 'content',
    snippet: () => `id: \${1:content_${randomId()}}
      fullscreen: true

      bookmark: |
        \${2:Your heading}

      heading: |
        \${2:Your heading}

      text: |
        \${3:Your text. *Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.*}\n`
  },

  {
    label: 'question',
    snippet: () => `id: \${1:question_${randomId()}}
      template: question
      fullscreen: true

      bookmark: |
        \${2:Your heading}

      heading: |
        \${2:Your heading}

      text: |
        \${3:Set up the context of the question here. *Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.*}

      question: |
        \${4:Ask the question.}

      options:
        - 1: |
          \${5:True}

        - 0: |
          \${6:False}

        - 0: |
          \${7:False}

        - 0: |
          \${8:False}

      feedback: |
        \${9:Your feedback here.}\n`
  },

  {
    label: 'split',
    snippet: () => `id: \${1:split_${randomId()}}
      template: split
      fullscreen: true

      bookmark: |
        \${2:Your heading}

      heading: |
        \${2:Your heading}

      text: |
        \${3:This text goes above the two columns.}

      left:
        - \${4}

      right:
        - \${5}\n`
  },

  {
    label: 'cards',
    snippet: () => `id: \${1:cards_${randomId()}}
      template: cards
      fullscreen: true

      bookmark: |
        \${2:Your heading}

      heading: |
        \${2:Your heading}
        
      text: |
        \${3:This text goes above the cards.}

      cols: \${4:3 # out of 12}
      
      cards:
        - \${5}\n`
  }
];
